export const CONCEPTS_PHILOSOPHIQUES = [{
        id: 1,
        expression: "La mauvaise foi",
        explication: "Se mentir à soi-même pour fuir sa propre liberté et refuser de prendre la responsabilité de ses actes.",
        créateur: "Jean-Paul Sartre (Existentialisme)"
    },
    {
        id: 2,
        expression: "Faire table rase (Tabula rasa)",
        explication: "Rejeter totalement le passé, les préjugés et les connaissances acquises pour repartir de zéro.",
        créateur: "John Locke (Empirisme) / Aristote"
    },
    {
        id: 3,
        expression: "L'impératif catégorique",
        explication: "Une règle morale absolue et universelle : agir de façon à ce que notre action puisse devenir une loi pour tous.",
        créateur: "Emmanuel Kant (Rationalisme)"
    },
    {
        id: 4,
        expression: "Le juste milieu",
        explication: "La recherche de la modération et de l'équilibre entre deux extrêmes (ex: le courage entre la lâcheté et la témérité).",
        créateur: "Aristote (Éthique à Nicomaque)"
    },
    {
        id: 5,
        expression: "L'inconscient",
        explication: "Partie de notre esprit psychique qui échappe totalement à notre conscience mais influence nos actes et désirs.",
        créateur: "Sigmund Freud (Psychanalyse)"
    },
    {
        id: 6,
        expression: "Le contrat social",
        explication: "L'accord fictif par lequel les individus renoncent à une part de leur liberté en échange de la sécurité de l'État.",
        créateur: "Jean-Jacques Rousseau / Thomas Hobbes"
    },
    {
        id: 7,
        expression: "Le Surhomme (Übermensch)",
        explication: "L'individu libre qui dépasse les morales établies pour créer ses propres valeurs avec force et créativité.",
        créateur: "Friedrich Nietzsche"
    },
    {
        id: 8,
        expression: "Le juste et l'injuste",
        explication: "La distinction morale fondamentale entre ce qui est conforme au droit naturel (l'équité) et ce qui le viole.",
        créateur: "Platon (La République)"
    },
    {
        id: 9,
        expression: "L'aliénation",
        explication: "Situation où un individu est dépossédé de lui-même, de son travail ou de sa liberté par un système qui le domine.",
        créateur: "Karl Marx (Marxisme) / Hegel"
    },
    {
        id: 10,
        expression: "Le cogito",
        explication: "La certitude absolue de sa propre existence par le simple fait de penser (« Je pense, donc je suis »).",
        créateur: "René Descartes (Rationalisme)"
    },
    {
        id: 11,
        expression: "L'altérité",
        explication: "La reconnaissance et le respect de l'autre dans sa différence radicale par rapport à soi-même.",
        créateur: "Emmanuel Levinas / Paul Ricœur"
    },
    {
        id: 12,
        expression: "Le carpe diem",
        explication: "L'art de cueillir le jour présent et de savourer l'instant sans gâcher sa vie par l'anxiété du futur.",
        créateur: "Épicure (Épicurisme) / Traduit par Horace"
    },
    {
        id: 13,
        expression: "L'état de nature",
        explication: "L'hypothèse d'une période primitive de l'humanité avant l'existence des lois, de la société et du gouvernement.",
        créateur: "Thomas Hobbes / John Locke"
    },
    {
        id: 14,
        expression: "Le panoptique",
        explication: "Un modèle de surveillance totale où un seul gardien peut observer tous les individus sans jamais être vu.",
        créateur: "Michel Foucault (Surveiller et punir) / Jeremy Bentham"
    },
    {
        id: 15,
        expression: "La résilience",
        explication: "La capacité psychologique à surmonter les chocs, les traumatismes et à se reconstruire malgré l'adversité.",
        créateur: "Concept philosophique et psychologique popularisé par Boris Cyrulnik"
    },
    {
        id: 16,
        expression: "Le libre arbitre",
        explication: "La faculté qu'a l'être humain de se déterminer librement et par sa seule volonté à agir ou ne pas agir.",
        créateur: "Saint Augustin (Philosophie chrétienne)"
    },
    {
        id: 17,
        expression: "Le machiavélisme",
        explication: "Une vision politique où la fin justifie les moyens, caractérisée par la ruse, le cynisme et la manipulation.",
        créateur: "Nicolas Machiavel (Le Prince)"
    },
    {
        id: 18,
        expression: "Le nihilisme",
        explication: "Doctrine ou attitude affirmant l'absence de valeurs absolues, de vérité objective ou de sens à l'existence.",
        créateur: "Friedrich Nietzsche / Courants révolutionnaires russes"
    },
    {
        id: 19,
        expression: "L'existentialisme",
        explication: "Courant affirmant que l'homme n'est pas prédéterminé : il existe d'abord, surgit dans le monde, et se définit ensuite par ses choix.",
        créateur: "Jean-Paul Sartre / Simone de Beauvoir"
    },
    {
        id: 20,
        expression: "L'épicurisme (Sens courant déformé)",
        explication: "La recherche des plaisirs simples, naturels et nécessaires pour atteindre l'absence de souffrance.",
        créateur: "Épicure (Grèce antique)"
    },
    {
        id: 21,
        expression: "Le stoïcisme (Sens courant)",
        explication: "Faire preuve de courage et d'impassibilité face aux coups du sort en acceptant ce qui ne dépend pas de nous.",
        créateur: "Épictète / Marc Aurèle / Sénèque"
    },
    {
        id: 22,
        expression: "Le scepticisme",
        explication: "Attitude de doute méthodique refusant d'admettre des vérités absolues sans examen critique rigoureux.",
        créateur: "Pyrrhon d'Élis (Antiquité)"
    },
    {
        id: 23,
        expression: "Le bonheur parfait (Ataraxie)",
        explication: "La tranquillité absolue de l'âme obtenue par l'extinction des désirs superflus et des peurs.",
        créateur: "Démocrite / Épicure"
    },
    {
        id: 24,
        expression: "L'utopie",
        explication: "Le portrait d'une société idéale, parfaite mais imaginaire, servant de critique à la société réelle.",
        créateur: "Thomas More (Ouvrage 'Utopia')"
    },
    {
        id: 25,
        expression: "Le déterminisme",
        explication: "Principe selon lequel chaque événement est rigoureusement déterminé par des causes antérieures selon les lois de la nature.",
        créateur: "Baruch Spinoza / Pierre-Simon de Laplace"
    },
    {
        id: 26,
        expression: "Le solipsisme",
        explication: "L'attitude philosophique extrême consistant à penser qu'il n'y a d'autre réalité que soi-même et sa propre conscience.",
        créateur: "Discussions sur le doute radical de Descartes"
    },
    {
        id: 27,
        expression: "La dialectique",
        explication: "Processus d'évolution de la pensée ou de la réalité par le dépassement d'une contradiction (Thèse-Antithèse-Synthèse).",
        créateur: "G.W.F. Hegel / Karl Marx"
    },
    {
        id: 28,
        expression: "Le scientisme",
        explication: "La croyance aveugle que la science expérimentale peut résoudre tous les problèmes de l'humanité et expliquer le monde.",
        créateur: "Ernest Renan / Positivisme du XIXe siècle"
    },
    {
        id: 29,
        expression: "La métaphysique",
        explication: "Recherche rationnelle portant sur des sujets invisibles ou immatériels qui dépassent l'expérience physique (Dieu, l'âme, le néant).",
        créateur: "Aristote (Nommé par Andronicos de Rhodes)"
    },
    {
        id: 30,
        expression: "L'empirisme",
        explication: "Théorie selon laquelle toutes nos connaissances proviennent exclusivement de l'expérience sensible et de l'observation.",
        créateur: "David Hume / John Locke"
    },
    {
        id: 31,
        expression: "L'esthétique",
        explication: "La branche de la philosophie qui étudie le beau, le goût, l'art et les émotions artistiques.",
        créateur: "Alexander Baumgarten / Emmanuel Kant"
    },
    {
        id: 32,
        expression: "L'éthique",
        explication: "La réflexion critique sur les valeurs morales et les règles de conduite pour mener une vie juste et bonne.",
        créateur: "Spinoza (Traité 'L'Éthique') / Aristote"
    },
    {
        id: 33,
        expression: "L'ontologie",
        explication: "L'étude philosophique de l'être en tant qu'être, de l'existence et des catégories fondamentales de ce qui est.",
        créateur: "Martin Heidegger / Sagesse grecque antique"
    },
    {
        id: 34,
        expression: "La casuistique",
        explication: "Méthode consistant à résoudre des problèmes de morale pratique au cas par cas en jouant avec la subtilité des règles.",
        créateur: "Théologie jésuite (Critiquée par Blaise Pascal)"
    },
    {
        id: 35,
        expression: "L'humanisme",
        explication: "Mouvement plaçant la dignité, l'épanouissement et la valeur de l'être humain au centre de toutes les préoccupations.",
        créateur: "Renaissance européenne (Érasme, Montaigne)"
    },
    {
        id: 36,
        expression: "Le fatalisme",
        explication: "La croyance selon laquelle tous les événements de la vie humaine sont fixés à l'avance par le destin, rendant toute action vaine.",
        créateur: "Stoïcisme ancien / Courants tragiques grecs"
    },
    {
        id: 37,
        expression: "Le relativisme",
        explication: "Idée selon laquelle les valeurs morales, esthétiques ou de vérité dépendent des époques, des cultures et des individus.",
        créateur: "Protagoras / Michel de Montaigne"
    },
    {
        id: 38,
        expression: "La phénoménologie",
        explication: "L'étude descriptive des choses telles qu'elles apparaissent directement à notre conscience, sans préjugé scientifique.",
        créateur: "Edmund Husserl"
    },
    {
        id: 39,
        expression: "L'idéalisme",
        explication: "Courant attribuant un rôle prépondérant aux idées et à l'esprit dans la construction et la connaissance de la réalité.",
        créateur: "Platon / Kant / Hegel"
    },
    {
        id: 40,
        expression: "Le matérialisme",
        explication: "Doctrine affirmant que seule la matière existe et que l'esprit, la pensée ou la conscience n'en sont que des produits.",
        créateur: "Épicure / Karl Marx"
    },
    {
        id: 41,
        expression: "Le pragmatisme",
        explication: "Doctrine mesurant la vérité ou la valeur d'une idée à ses résultats pratiques, son efficacité et ses conséquences réelles.",
        créateur: "William James / John Dewey"
    },
    {
        id: 42,
        expression: "L'absurde",
        explication: "Le sentiment de décalage tragique entre le besoin de sens de l'homme et le silence incompréhensible du monde.",
        créateur: "Albert Camus (Le Mythe de Sisyphe)"
    },
    {
        id: 43,
        expression: "La raison d'État",
        explication: "Le principe politique autorisant un gouvernement à violer la légalité ou la morale au nom du salut public ou de l'intérêt national.",
        créateur: "Théorisée durant la Renaissance italienne et française"
    },
    {
        id: 44,
        expression: "La transcendance",
        explication: "Ce qui s'élève au-dessus, dépasse le monde sensible et se situe hors de portée de l'expérience humaine ordinaire.",
        créateur: "Philosophies religieuses et théologiques"
    },
    {
        id: 45,
        expression: "L'immanence",
        explication: "Le fait qu'un principe ou une force réside entièrement à l'intérieur des êtres, du monde ou de la nature elle-même.",
        créateur: "Baruch Spinoza (« Dieu ou la Nature »)"
    },
    {
        id: 46,
        expression: "Le rationalisme",
        explication: "Doctrine qui pose la raison humaine comme la source principale ou unique de toute vraie connaissance.",
        créateur: "René Descartes / Spinoza"
    },
    {
        id: 47,
        expression: "La déconstruction",
        explication: "Méthode d'analyse visant à démonter la structure des textes et des concepts pour révéler leurs contradictions cachées.",
        créateur: "Jacques Derrida"
    },
    {
        id: 48,
        expression: "Le pessimisme philosophique",
        explication: "Doctrine selon laquelle la souffrance est inhérente à la vie et que notre monde est gouverné par un vouloir-vivre aveugle.",
        créateur: "Arthur Schopenhauer"
    },
    {
        id: 49,
        expression: "L'obscurantisme",
        explication: "Attitude d'opposition systématique à la diffusion des lumières du savoir, de la science et de l'esprit critique.",
        créateur: "Combat des philosophes des Lumières au XVIIIe siècle"
    },
    {
        id: 50,
        expression: "La perfectibilité",
        explication: "La capacité spécifique de l'être humain à se transformer, à apprendre et à s'améliorer tout au long de son existence.",
        créateur: "Jean-Jacques Rousseau"
    },
    {
        id: 51,
        expression: "La métanie (Metanoia)",
        explication: "Le processus de conversion intime, de changement radical de regard ou de transformation spirituelle d'un individu.",
        créateur: "Philosophie hellénistique et théologique antique"
    },
    {
        id: 52,
        expression: "Le perspectivisme",
        explication: "Idée selon laquelle il n'existe pas de faits purs ou de vérité ultime, mais seulement des interprétations liées à des points de vue.",
        créateur: "Friedrich Nietzsche"
    },
    {
        id: 53,
        expression: "L'heuristique de la peur",
        explication: "Principe éthique consistant à imaginer le pire scénario technologique ou écologique possible pour prendre des décisions responsables aujourd'hui.",
        créateur: "Hans Jonas (Le Principe responsabilité)"
    },
    {
        id: 54,
        expression: "Le biopouvoir",
        explication: "Les techniques utilisées par les États modernes pour gérer, contrôler et réguler les corps et les populations.",
        créateur: "Michel Foucault"
    },
    {
        id: 55,
        expression: "La tyrannie de la majorité",
        explication: "Le risque démocratique où le pouvoir du plus grand nombre étouffe ou opprime les libertés des minorités.",
        créateur: "Alexis de Tocqueville (De la démocratie en Amérique)"
    },
    {
        id: 56,
        expression: "L'étonnement philosophique",
        explication: "La capacité d'émerveillement ou de surprise face au monde, considérée comme le point de départ de toute philosophie.",
        créateur: "Platon / Aristote"
    },
    {
        id: 57,
        expression: "Le positivisme",
        explication: "Doctrine n'accordant de valeur qu'aux faits vérifiables par l'expérience scientifique et rejetant toute spéculation métaphysique.",
        créateur: "Auguste Comte"
    },
    {
        id: 58,
        expression: "L'hétéronomie",
        explication: "Le fait de subir la loi d'un autre ou d'éléments extérieurs (impulsions, pressions) plutôt que de s'obéir à sa propre raison.",
        créateur: "Emmanuel Kant"
    },
    {
        id: 59,
        expression: "L'autonomie",
        explication: "La capacité d'un individu à se donner à lui-même ses propres lois morales en s'appuyer sur sa liberté et sa raison.",
        créateur: "Emmanuel Kant"
    },
    {
        id: 60,
        expression: "L'ascétisme",
        explication: "Discipline de vie rigoureuse faite de privations et d'exercices spirituels pour atteindre la perfection morale ou la maîtrise de soi.",
        créateur: "Traditions philosophiques pythagoriciennes et stoïciennes"
    },
    {
        id: 61,
        expression: "Le divertissement pascalien",
        explication: "Toutes les activités (jeux, travail, bavardages) que l'homme invente pour fuir l'ennui et oublier sa propre mortalité.",
        créateur: "Blaise Pascal (Les Pensées)"
    },
    {
        id: 62,
        expression: "La cathédrale de la raison",
        explication: "La construction intellectuelle et rigoureuse visant à organiser l'ensemble des connaissances humaines de manière logique.",
        créateur: "Emmanuel Kant (Métaphore de la Critique de la raison pure)"
    },
    {
        id: 63,
        expression: "Le rasoir d'Ockham",
        explication: "Principe de simplicité stipulant que l'explication la plus simple et contenant le moins d'hypothèses est souvent la meilleure.",
        créateur: "Guillaume d'Ockham (Scolastique médiévale)"
    },
    {
        id: 64,
        expression: "La servitude volontaire",
        explication: "Le paradoxe par lequel des peuples entiers acceptent de se soumettre à un tyran par habitude ou par confort.",
        créateur: "Étienne de La Boétie (Discours de la servitude volontaire)"
    },
    {
        id: 65,
        expression: "L'utilitarisme",
        explication: "Doctrine éthique selon laquelle la valeur d'une action se mesure à sa capacité à maximiser le bonheur du plus grand nombre.",
        créateur: "Jeremy Bentham / John Stuart Mill"
    },
    {
        id: 66,
        expression: "L'amour de soi",
        explication: "Un sentiment naturel et positif qui pousse l'être humain à veiller à sa propre conservation et à son bien-être.",
        créateur: "Jean-Jacques Rousseau (Discours sur l'créateur de l'inégalité)"
    },
    {
        id: 67,
        expression: "L'amour-propre",
        explication: "Un sentiment factice né du regard des autres, qui pousse à la vanité, à la jalousie et à la rivalité sociale.",
        créateur: "Jean-Jacques Rousseau"
    },
    {
        id: 68,
        expression: "L'esprit de finesse",
        explication: "La capacité intuitive à comprendre les choses complexes du quotidien d'un seul coup d'œil, sans démonstration logique.",
        créateur: "Blaise Pascal"
    },
    {
        id: 69,
        expression: "L'esprit de géométrie",
        explication: "La capacité à raisonner de manière purement logique, lente, déductive et mathématique.",
        créateur: "Blaise Pascal"
    },
    {
        id: 70,
        expression: "La banalité du mal",
        explication: "Le fait que des crimes monstrueux puissent être commis par des gens ordinaires simplement par conformisme et obéissance.",
        créateur: "Hannah Arendt (Eichmann à Jérusalem)"
    },
    {
        id: 71,
        expression: "La volonté de puissance",
        explication: "La force vitale fondamentale qui pousse tout être vivant à s'étendre, s'affirmer et se dépasser continuellement.",
        créateur: "Friedrich Nietzsche"
    },
    {
        id: 72,
        expression: "Le désenchantement du monde",
        explication: "Le processus de recul des croyances magiques et religieuses au profit des explications scientifiques et rationnelles.",
        créateur: "Max Weber (Sociologie des religions)"
    },
    {
        id: 73,
        expression: "La perfectibilité",
        explication: "La faculté de se développer et de s'éduquer, qui distingue l'être humain de l'animal.",
        créateur: "Jean-Jacques Rousseau"
    },
    {
        id: 74,
        expression: "L'homme révolté",
        explication: "L'individu qui refuse l'oppression et l'absurdité de sa condition pour affirmer la dignité commune à tous les hommes.",
        créateur: "Albert Camus"
    },
    {
        id: 75,
        expression: "Le deuil de Dieu",
        explication: "La prise de conscience moderne de la perte de fondement absolu pour la morale et les valeurs métaphysiques.",
        créateur: "Friedrich Nietzsche (Ainsi parlait Zarathoustra)"
    },
    {
        id: 76,
        expression: "L'arbre des sciences",
        explication: "Métaphore comparant la philosophie aux racines et les sciences physiques ou médicales aux branches d'un même tronc.",
        créateur: "René Descartes (Principes de la philosophie)"
    },
    {
        id: 77,
        expression: "La conscience de soi",
        explication: "La faculté d'un être de se prendre lui-même comme objet de pensée et d'analyse.",
        créateur: "G.W.F. Hegel / Phénoménologie de l'esprit"
    },
    {
        id: 78,
        expression: "Le voile d'ignorance",
        explication: "Expérience de pensée où l'on imagine les lois d'une société juste sans savoir quelle place on y occupera soi-même.",
        créateur: "John Rawls (Théorie de la justice)"
    },
    {
        id: 79,
        expression: "La guerre de tous contre tous",
        explication: "La condition tragique de l'homme à l'état de nature, où l'absence de lois engendre une peur constante de la mort violente.",
        créateur: "Thomas Hobbes (Léviathan)"
    },
    {
        id: 80,
        expression: "L'obsolescence de l'homme",
        explication: "La thèse selon laquelle le développement des technologies rend les capacités de l'être humain inférieures et dépassées.",
        créateur: "Günther Anders"
    },
    {
        id: 81,
        expression: "La société du spectacle",
        explication: "Une critique sociale montrant que les relations humaines directes ont été remplacées par des images et des marchandises.",
        créateur: "Guy Debord (Situationnisme)"
    },
    {
        id: 82,
        expression: "La délation éthique",
        explication: "Dilemme moral où la dénonciation d'un acte est perçue soit comme un devoir civique, soit comme une trahison personnelle.",
        créateur: "Éthique appliquée et philosophie du droit"
    },
    {
        id: 83,
        expression: "Le gai savoir",
        explication: "Une approche de la connaissance libérée du sérieux dogmatique, célébrant la vie, l'art et l'expérimentation.",
        créateur: "Friedrich Nietzsche"
    },
    {
        id: 84,
        expression: "La raison instrumentale",
        explication: "Une forme de pensée axée uniquement sur l'efficacité technique et les moyens, sans s'interroger sur la valeur morale des fins.",
        créateur: "École de Francfort (Max Horkheimer / Theodor Adorno)"
    },
    {
        id: 85,
        expression: "L'ordre symbolique",
        explication: "Le réseau invisible de règles, de langage et de coutumes sociales qui structurent l'esprit d'un être humain.",
        créateur: "Jacques Lacan (Psychanalyse structurale)"
    },
    {
        id: 86,
        expression: "La volonté générale",
        explication: "La volonté commune des citoyens orientée exclusivement vers l'intérêt public, distincte de la somme des intérêts privés.",
        créateur: "Jean-Jacques Rousseau (Du contrat social)"
    },
    {
        id: 87,
        expression: "Le principe de responsabilité",
        explication: "L'obligation éthique d'agir de façon à ce que les conséquences de nos actes ne détruisent pas l'avenir de la vie sur Terre.",
        créateur: "Hans Jonas"
    },
    {
        id: 88,
        expression: "La ruse de la raison",
        explication: "L'idée que l'Histoire avance vers le progrès en utilisant les passions égoïstes et les conflits des hommes à leur insu.",
        créateur: "G.W.F. Hegel"
    },
    {
        id: 89,
        expression: "La main invisible",
        explication: "Théorie économique selon laquelle la recherche des intérêts individuels concourt inconsciemment au bien commun de la société.",
        créateur: "Adam Smith (La Richesse des nations)"
    },
    {
        id: 90,
        expression: "L'enfer, c'est les autres",
        explication: "Formule soulignant que notre propre identité et notre valeur dépendent cruellement du jugement et du regard d'autrui.",
        créateur: "Jean-Paul Sartre (Huis clos)"
    },
    {
        id: 91,
        expression: "L'animal machine",
        explication: "Théorie affirmant que les animaux n'ont ni âme ni conscience et fonctionnent comme des mécanismes d'horlogerie perfectionnés.",
        créateur: "René Descartes"
    },
    {
        id: 92,
        expression: "Le meilleur des mondes possibles",
        explication: "Idée optimiste selon laquelle le monde créé par Dieu contient la plus grande perfection mathématique possible malgré le mal apparent.",
        créateur: "Gottfried Wilhelm Leibniz"
    },
    {
        id: 93,
        expression: "La docte ignorance",
        explication: "Le plus haut degré du savoir qui consiste à avoir conscience de l'immensité de ce qui reste inconnu.",
        créateur: "Nicolas de Cues"
    },
    {
        id: 94,
        expression: "Le dasein",
        explication: "Le mode d'existence spécifique de l'être humain, caractérisé par le fait de se questionner sur sa propre présence dans le monde.",
        créateur: "Martin Heidegger (Être et Temps)"
    },
    {
        id: 95,
        expression: "L'horizon d'attente",
        explication: "L'ensemble des références, des croyances et des espoirs partagés par une génération à une époque donnée de l'Histoire.",
        créateur: "Reinhart Koselleck (Histoire des concepts)"
    },
    {
        id: 96,
        expression: "Le pharmakon",
        explication: "Un concept désignant une chose qui peut agir à la fois comme un remède et comme un poison selon son dosage (ex: la technologie).",
        créateur: "Platon (Dialogue du Phèdre) / Repris par Bernard Stiegler"
    },
    {
        id: 97,
        expression: "Le panthéisme",
        explication: "Système philosophique assimilant Dieu à la nature entière, excluant l'existence d'un dieu créateur anthropomorphe.",
        créateur: "Baruch Spinoza"
    },
    {
        id: 98,
        expression: "La libre pensée",
        explication: "L'attitude consistant à refuser les dogmes religieux ou politiques pour forger ses convictions par sa seule raison.",
        créateur: "Mouvement des Lumières (Voltaire)"
    },
    {
        id: 99,
        expression: "Le paradigme",
        explication: "Un modèle cohérent de pensée, une vision du monde partagée par la communauté scientifique à une époque donnée.",
        créateur: "Thomas Kuhn (La Structure des révolutions scientifiques)"
    },
    {
        id: 100,
        expression: "La sagesse tragique",
        explication: "L'acceptation enthousiaste de la vie dans sa globalité, incluant la souffrance et la mort, sans chercher de refuge imaginaire.",
        créateur: "Friedrich Nietzsche"
    }
];